<template>
  <DefaultLayout>
    <div class="page-header">
      <h1>Perfil del Tenant</h1>
    </div>

    <div class="grid-2">
      <Card>
        <template #title>Información</template>
        <template #content>
          <div v-if="tenant" class="info-list">
            <div class="info-row"><span class="label">Nombre</span><span>{{ tenant.name }}</span></div>
            <div class="info-row"><span class="label">Email</span><span>{{ tenant.email }}</span></div>
            <div class="info-row"><span class="label">Estado</span>
              <Tag :severity="statusSeverity(tenant.subscription_status)" :value="tenant.subscription_status" />
            </div>
            <div class="info-row"><span class="label">Plan</span><span>{{ tenant.plan_id ?? 'Sin plan' }}</span></div>
          </div>
          <p v-else class="empty-msg">Cargando...</p>
        </template>
      </Card>

      <Card>
        <template #title>Uso de Tokens</template>
        <template #content>
          <div v-if="balance" class="info-list">
            <div class="info-row"><span class="label">Usados</span><span>{{ balance.tokens_used?.toLocaleString() }}</span></div>
            <div class="info-row"><span class="label">Restantes</span>
              <span>{{ balance.is_unlimited ? '∞' : balance.tokens_remaining?.toLocaleString() }}</span>
            </div>
          </div>
        </template>
      </Card>
    </div>

    <Card class="mt-4">
      <template #title>Sub-tenants</template>
      <template #content>
        <SubTenantList :tenant-id="authStore.user?.tenant_id" />
      </template>
    </Card>
  </DefaultLayout>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useAuthStore } from '../stores/auth';
import DefaultLayout from '../components/layout/DefaultLayout.vue';
import SubTenantList from '../components/tenants/SubTenantList.vue';
import Card from 'primevue/card';
import Tag from 'primevue/tag';
import { tenantsService } from '../services/tenants';
import { tokensService } from '../services/tokens';

const authStore = useAuthStore();
const tenant = ref(null);
const balance = ref(null);

const statusSeverity = (s) => ({ active: 'success', past_due: 'warning', suspended: 'danger', inactive: 'secondary' }[s] || 'info');

onMounted(async () => {
  const tid = authStore.user?.tenant_id;
  if (!tid) return;
  try {
    [tenant.value, balance.value] = await Promise.all([
      tenantsService.getTenantById(tid),
      tokensService.getTokenUsage(tid),
    ]);
  } catch (e) { console.error(e); }
});
</script>

<style scoped>
.page-header { margin-bottom: 1.5rem; }
.page-header h1 { color: #1e293b; }
.grid-2 { display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 1.5rem; }
.info-list { display: flex; flex-direction: column; gap: 0.75rem; }
.info-row { display: flex; justify-content: space-between; align-items: center; padding: 0.5rem 0; border-bottom: 1px solid #f3f4f6; }
.label { font-weight: 600; color: #6b7280; }
.empty-msg { color: #9ca3af; }
.mt-4 { margin-top: 1.5rem; }
</style>
